<template>
    <div>
        <h3 class="is-size-3">INEGI Geoestadisticas</h3>
        <p>
            <code>GET {{ host }}/api/inegiMunicipalities/{stateCode?}</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene un parámetro:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>stateCode</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. 01)</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>
            [
                {
                    "geoCode": "01001",
                    "stateCode": "01",
                    "muncipalityCode": "001",
                    "muncipalityName": "Aguascalientes",
                    "popFem": 486917,
                    "popMasc": 462073,
                    "population": 948990,
                    "household": 266942
                },
                {
                    "geoCode": "01002",
                    "stateCode": "01",
                    "muncipalityCode": "002",
                    "muncipalityName": "Asientos",
                    "popFem": 26275,
                    "popMasc": 25261,
                    "population": 51536,
                    "household": 12544
                },
                {
                    "geoCode": "01003",
                    "stateCode": "01",
                    "muncipalityCode": "003",
                    "muncipalityName": "Calvillo",
                    "popFem": 29687,
                    "popMasc": 28563,
                    "population": 58250,
                    "household": 15556
                },
                {
                    "geoCode": "01004",
                    "stateCode": "01",
                    "muncipalityCode": "004",
                    "muncipalityName": "Cosío",
                    "popFem": 8708,
                    "popMasc": 8292,
                    "population": 17000,
                    "household": 3938
                },
                {
                    "geoCode": "01005",
                    "stateCode": "01",
                    "muncipalityCode": "005",
                    "muncipalityName": "Jesús María",
                    "popFem": 65710,
                    "popMasc": 64219,
                    "population": 129929,
                    "household": 33229
                },
                {
                    "geoCode": "01006",
                    "stateCode": "01",
                    "muncipalityCode": "006",
                    "muncipalityName": "Pabellón de Arteaga",
                    "popFem": 24269,
                    "popMasc": 23377,
                    "population": 47646,
                    "household": 11470
                },
                {
                    "geoCode": "01007",
                    "stateCode": "01",
                    "muncipalityCode": "007",
                    "muncipalityName": "Rincón de Romos",
                    "popFem": 29268,
                    "popMasc": 28101,
                    "population": 57369,
                    "household": 13584
                },
                {
                    "geoCode": "01008",
                    "stateCode": "01",
                    "muncipalityCode": "008",
                    "muncipalityName": "San José de Gracia",
                    "popFem": 5020,
                    "popMasc": 4532,
                    "population": 9552,
                    "household": 2381
                },
                {
                    "geoCode": "01009",
                    "stateCode": "01",
                    "muncipalityCode": "009",
                    "muncipalityName": "Tepezalá",
                    "popFem": 11371,
                    "popMasc": 11114,
                    "population": 22485,
                    "household": 5425
                },
                {
                    "geoCode": "01010",
                    "stateCode": "01",
                    "muncipalityCode": "010",
                    "muncipalityName": "El Llano",
                    "popFem": 10407,
                    "popMasc": 10446,
                    "population": 20853,
                    "household": 5211
                },
                {
                    "geoCode": "01011",
                    "stateCode": "01",
                    "muncipalityCode": "011",
                    "muncipalityName": "San Francisco de los Romo",
                    "popFem": 31292,
                    "popMasc": 30705,
                    "population": 61997,
                    "household": 16391
                }
        ]
        </code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>